import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import React from "react";
import { useI18n } from "../../../../i18n/i18n";
import { selectV2Theme } from "../selectV2Theme";
import { OptionBaseStyled } from "./OptionBaseStyled";
import type { OptionBaseStyledProps } from "./OptionBaseStyled";

const NoResultsMessageStyled = styled(OptionBaseStyled)`
    color: ${color("color--text--neutral--weak")};
    pointer-events: none;
    text-align: ${({ themeMode }) => selectV2Theme.option.noResults.textAlign(themeMode)};
    font-size: ${({ themeMode }) => selectV2Theme.option.noResults.fontSize(themeMode)};
`;

export const NoResultsMessage = (props: OptionBaseStyledProps) => {
    const { i18n } = useI18n();

    return (
        <NoResultsMessageStyled {...props}>
            {i18n._(
                /*i18n*/ {
                    comment:
                        "Displayed when there are no results to show, either due to lack of data, or lack of matching after a search.",
                    id: "No results found.",
                }
            )}
        </NoResultsMessageStyled>
    );
};
